var o = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function l(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
export {
  o as c,
  l as g
};
//# sourceMappingURL=_commonjsHelpers-DaMA6jEr.js.map
